<template>
  <div>
    <HeadTop />
    <div class="conBG">
      <ul class="menuList">
        <li
          v-for="(item, index) in list"
          :key="item.id"
          :class="{ active: navIndex == index }"
          @click="
					navIndex = index;
				to(item);
				"
        >
          {{ item.name }}
        </li>
        <div style="clear: both"></div>
      </ul>
      <router-view />
    </div>
  </div>
</template>

<script>
import HeadTop from "@/components/header.vue";
export default {
  data() {
    return {
      navIndex: 0,
      list: [
        {
          id: "superadmincompany",
          name: "公司管理",
        },
        {
          id: "superadminproject",
          name: "项目管理",
        },
        {
          id: "superadminmenu",
          name: "菜单管理",
        },
        {
          id: "superadminhome",
          name: "首页模块管理",
        },
        {
          id: "superadminprovince",
          name: "省份模板管理",
        },
        {
          id: "distributionBoxManagement",
          name: "动火配电箱管理",
        },
        {
          id: "customizedManagement",
          name: "定制化管理",
        },
        {
          id: "userManagement",
          name: "整合用户管理",
        }, {
          id: "implementManagement",
          name: "实施管理",
        }, {
          id: "trainManagement",
          name: "培训管理",
        }, {
          id: "hardwareStatistic",
          name: "统计分析",
        }
        //   {
        //   id: 'companyMenu',
        //   name: '公司级菜单管理'
        // },
      ],
      Is117: false,
    };
  },
  components: {
    HeadTop,
  },
  mounted() {
    if (window.location.hostname !== '117.78.39.56') {
      this.list = this.list.slice(0, 7)
    }
    this.to(this.list[0])
  },
  methods: {
    to(v) {
      this.$router.push({
        name: v.id,
      });
    },
  },
};
</script>

<style></style>